import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'configuraciones-pago/';

export interface ConfiguracionPago {
    id: number;
    nombre: string;
    tipo: 'efectivo' | 'banco' | 'otro';
    afecta_caja: boolean;
    requiere_cambio: boolean;
    permite_monto_personalizado: boolean;
    activo: boolean;
    fecha_creacion: string;
}

// GET: Obtener todas las configuraciones
export const fetchConfiguracionesPago = async (): Promise<ConfiguracionPago[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ConfiguracionPago[]>(API_URL);
        return response.data;
    });
};

// POST: Crear una nueva configuración
export const createConfiguracionPago = async (data: {
    nombre: string;
    tipo: 'efectivo' | 'banco' | 'otro';
    afecta_caja: boolean;
    requiere_cambio: boolean;
    permite_monto_personalizado: boolean;   // Nuevo campo
    activo: boolean;
}): Promise<ConfiguracionPago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post<ConfiguracionPago>(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar configuración existente
export const updateConfiguracionPago = async (
    id: number,
    data: {
        nombre: string;
        tipo: 'efectivo' | 'banco' | 'otro';
        afecta_caja: boolean;
        requiere_cambio: boolean;
        permite_monto_personalizado: boolean;   // Nuevo campo
        activo: boolean;
    }
): Promise<ConfiguracionPago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put<ConfiguracionPago>(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar
export const deleteConfiguracionPago = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};